import { Link } from "react-router-dom";
import { ArrowRight, Clock } from "lucide-react";
import { IMG, waLink } from "@/lib/brand";

const posts = [
  { title: "10 Study Habits That Turned Average Students Into Toppers", excerpt: "Simple daily habits every Class 9 & 10 student should build to score above 90%.", tag: "Study Tips", read: "6 min" },
  { title: "CBSE vs ICSE — Which Board Is Better for Your Child?", excerpt: "A teacher's honest comparison of CBSE and ICSE for parents in Patna.", tag: "Boards", read: "8 min" },
  { title: "How to Score 95%+ in Class 10 — A Realistic Plan", excerpt: "Month-by-month strategy from our teachers for CBSE and ICSE board students.", tag: "Board Prep", read: "10 min" },
  { title: "The Right Way to Solve Maths — Stop Making These 5 Mistakes", excerpt: "Common mistakes Class 8–10 students make in Maths and how to fix them.", tag: "Maths", read: "5 min" },
  { title: "Why Small Batch Coaching Beats Big Coaching Centres", excerpt: "The science behind why small batches outperform mass coaching classes.", tag: "Learning", read: "4 min" },
  { title: "Parent's Guide: Supporting Your Child During Board Exams", excerpt: "Practical do's and don'ts for parents of Class 10 students.", tag: "Parents", read: "7 min" },
  { title: "Best Reference Books for CBSE Class 9 & 10", excerpt: "Curated book list — from NCERT to R.D. Sharma to All-in-One guides.", tag: "Resources", read: "6 min" },
  { title: "How to Overcome Exam Fear — A Teacher's Toolkit", excerpt: "Techniques that help students stay calm and confident during exams.", tag: "Mindset", read: "5 min" },
];

export default function BlogPage() {
  return (
    <div>
      <section className="bg-[#0B192C] text-white relative overflow-hidden">
        <div className="vk-grain" />
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
          <span className="vk-chip">The Vikramshila Classes Blog</span>
          <h1 className="mt-4 font-display text-5xl sm:text-6xl font-800 tracking-tight max-w-3xl">Insights from the classroom.</h1>
          <p className="mt-5 max-w-2xl text-lg text-white/70">Study tips, exam strategies, and parenting advice — straight from the whiteboard to your inbox.</p>
        </div>
      </section>

      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {posts.map((p,i)=>(
            <article key={i} data-testid={`blog-post-${i}`} className="rounded-lg border border-slate-200 overflow-hidden bg-white flex flex-col group hover:border-[#FF6B35] transition-colors">
              <div className="aspect-[16/10] overflow-hidden bg-slate-100">
                <img src={i%2===0 ? IMG.studyMaterials : IMG.classroom} alt={p.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform" loading="lazy" />
              </div>
              <div className="p-6 flex-1 flex flex-col">
                <div className="flex items-center gap-3 text-xs text-slate-500">
                  <span className="vk-chip">{p.tag}</span>
                  <span className="flex items-center gap-1"><Clock size={12} /> {p.read}</span>
                </div>
                <h3 className="mt-4 font-display text-xl font-bold text-[#0B192C] leading-snug">{p.title}</h3>
                <p className="mt-2 text-sm text-slate-600 flex-1">{p.excerpt}</p>
                <div className="mt-5 inline-flex items-center gap-2 text-sm font-semibold text-[#FF6B35]">
                  Read more <ArrowRight size={14} className="transition-transform group-hover:translate-x-1" />
                </div>
              </div>
            </article>
          ))}
        </div>
      </section>

      <section className="py-16 bg-[#0B192C] text-white relative overflow-hidden">
        <div className="vk-grain" />
        <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="font-display text-4xl font-800">Prefer 1-on-1 guidance?</h2>
          <div className="mt-6 flex flex-wrap justify-center gap-3">
            <Link to="/contact" className="vk-btn-primary">Book Free Demo <ArrowRight size={16} /></Link>
            <a href={waLink()} target="_blank" rel="noreferrer" className="vk-btn-outline">WhatsApp Now</a>
          </div>
        </div>
      </section>
    </div>
  );
}
